<template>
  <v-container fluid class="pa-0">
    <v-progress-linear indeterminate v-if="previewLoading" height="5"></v-progress-linear>
    <v-menu v-model="menu" :close-on-content-click="false" min-width="440" max-width="440" :nudge-left="200" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="elevation-0 mr-3 notes-wrapper" fab fixed  v-bind="attrs" small  v-on="on" :color="listOfNotes.length > 0 ? 'info' : ''">
          <v-icon class="pr-5">mdi-clipboard-text-multiple-outline  </v-icon> {{ `(${listOfNotes.length})` }}
        </v-btn>
      </template>
          <v-card>
            <v-toolbar color="light-blue" light height="50px">
              <v-toolbar-title class="white--text">
                <v-icon dark class="mr-5">mdi-calendar-text</v-icon>
                {{ $t('message.tickets.personalNotes') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn  small icon @click="showNoteBox = true" v-if="!showNoteBox" dark>
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
              <v-btn icon dark v-if="selected.length > 0" @click="deleteNotes">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn icon dark @click="menu = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-list two-line subheader v-if="listOfNotes.length > 0" class="mt-4">
              <v-list-item v-for="(item, index) in listOfNotes" :key="index" link>
                 <v-list-item-action>
              <v-checkbox v-model="item.isSelceted" @change="addToSelected($event, item)"
                color="primary"
              ></v-checkbox>
            </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-html="item.note" class="v-toolbar__title notes-overflow"></v-list-item-title>
                <v-list-item-subtitle>{{item.user_firstname}} {{item.user_lastname}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ $formatter.formatDate(item.created_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon x-small>
                  <v-icon color="grey lighten-1" @click="editNotes(index)">mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        <template v-else>
           <v-alert prominent text type="info" class="mt-2" >
      <v-row align="center">
        <v-col class="grow">{{ $t('message.common.noNotes') }}</v-col>
      </v-row>
    </v-alert>
        </template>
        <div class="pa-2 ma-2 mb-0 justify-right actual-editor">
            <template v-if="showNoteBox">
              <ckeditor :editor="editor" v-model="notesObj.notes" :config="noteConfig" ref="editor"></ckeditor>
               <v-flex class="text-right">
                  <v-btn-toggle v-model="toggle_exclusive" class="justify-right">
                    <v-btn small @click="saveNotes">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn small @click="showNoteBox = false, notesObj = {}">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-btn-toggle>
              </v-flex>
            </template>
          </div>
      </v-card>
    </v-menu>
    <v-row class="pa-1">
      <v-flex class="ticket-view lg3 md4 sm4 xs12 pa-1">
      <v-tabs v-model="tab" background-color="primary" dark fixed-tabs>
        <v-tab  v-for="(item, i) in tabs" :key="i">
          {{ item.name }} {{ item.id === 1 ? `(${listOfComments.length})` : '' }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
      <v-tab-item  v-for="(item, keyIndex) in tabs" :key="keyIndex">
        <template v-if="item.id === 0">
          <div class="mt-6">
            <h4 :style="$vuetify.theme.dark ? 'color: #dacdcd' : ''">{{ $t('message.orders.createdBy') }} : {{ getCreatedBy() }}</h4>
            <form-data :references.sync="formReferences" :model="modelObj" ref="ticketViewEditReference">
            </form-data>
            <template v-if="relatedOrders && relatedOrders.length > 0">
              <h4 class="mt-2">{{ $t('message.layout.salesOrOffer') }}</h4>
              <a v-for="(record, index) in relatedOrders" :key="index" :href="`/orders/edit/${record.id}/view`" >
                {{ record.number }} {{ relatedOrders.length - 1 === index ? '' : ',' }}
              </a>
            </template>
          </div>
        </template>
        <v-card flat v-else class="pa-0">
          <v-card-text class="pa-1">
            <comments-section :ticketNumber="modelObj.number" :assignedto="modelObj.assignedto" :listOfComments="listOfComments"></comments-section>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
      </v-flex>
      <v-flex class="lg9 md8 sm8 xs12 pa-1">
        <v-card class="pb-1 custom-ckeditor-height">
          <v-card-title class="pa-1">
            <v-btn color="primary" @click="backToList()" fab x-small>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span class="pl-4">{{ modelObj.number }}</span>
            <v-chip class="ma-2" color="cyan" label text-color="white" v-if="mailsMerged">
              {{ mailsMerged | singularPluralData }}
            </v-chip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card outlined class="ma-1 mt-3" v-for="(item, index) in ticketMails" :key="index">
            <v-card-title class="pa-0 pl-2 pr-2">
              <v-row>
                <v-col cols="12" lg="8">
                  <template v-if="showFieldsForTask">
                    <v-text-field dense hide-details outlined v-model="updateMailInfo.subject"></v-text-field>
                  </template>
                  <template v-else>
                    <span  >{{item.subject}}</span>
                  </template>
                </v-col>
                <v-col cols="12" lg="4" class="text-right">
                  <span class="subtitle-1">{{ $formatter.formatDate(item.datetime, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm')}}</span>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider intense></v-divider>
            <v-row>
              <v-col cols="12" lg="10" sm="12" class="py-0 px-2">
                <v-row class="pa-0">
                  <v-col cols="12" lg="6" md="6" class="py-0 px-2"  v-if="item.mailfrom && item.mailfrom.length > 0">
                    <v-card-text class="subtitle-2">{{$t('message.tickets.from')}}
                      <v-chip class="mb-0" small>{{item.mailfrom[0].Address}}</v-chip>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" class="py-0 px-2"  v-if="item.mailto && item.mailto.length > 0">
                    <v-card-text class="subtitle-2">{{$t('message.tickets.to')}}
                      <v-chip class="mb-0" small>{{item.mailto.map(function(elem){return elem.Address}).join(",")}}</v-chip>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" class="py-0 px-2"  v-if="item.mailcc && item.mailcc.length > 0">
                    <v-card-text class="subtitle-2">{{$t('message.tickets.cc')}}
                      <span>
                        <v-chip class="mb-0" small>{{item.mailcc.map(function(elem){return elem.Address}).join(",")}}</v-chip>
                      </span>
                      <!-- <v-chip class="mb-0" small>{{item.mailfrom[0].Address}}</v-chip> -->
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" class="py-0 px-2"  v-if="item.mailbcc && item.mailbcc.length > 0">
                    <v-card-text class="subtitle-2">{{$t('message.tickets.bcc')}}
                      <!-- <v-chip class="mb-0" small>{{item.mailto[0].Address}}</v-chip> -->
                       <span>
                        <v-chip class="mb-0" small>{{item.mailbcc.map(function(elem){return elem.Address}).join(",")}}</v-chip>
                      </span>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="2" sm="12" class="text-right py-0" v-if="!modelObj.is_task">
                <v-btn color="primary" icon @click="replyMail(item, index)">
                    <v-icon>mdi-reply</v-icon>
                  </v-btn>
                   <v-btn color="primary" icon @click="replyAllMail(item, index)">
                    <v-icon>mdi-reply-all</v-icon>
                  </v-btn>
                  <v-btn color="primary" icon @click="forwardMail(item, index)" v-if="!modelObj.is_task">
                    <v-icon>mdi-forward</v-icon>
                  </v-btn>
              </v-col>
              <v-col cols="12" lg="2" sm="12" class="text-right py-0" v-else>
                 <v-btn color="primary" icon @click="showMailInfoEdit(item, index)" v-if="!showFieldsForTask">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <template v-if="showFieldsForTask">
                    <v-btn color="success" icon @click="updateMailValues">
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn color="error" icon @click="showFieldsForTask = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-sheet>
                <template v-if="!showFieldsForTask">
                  <div v-if="!isHTML(item.body)" class="text-block-html">{{ convertHtml(item) }}</div>
                  <iframe v-else :srcdoc="convertHtml(item)" style="width: 100%;height: 80vh;overflow:hidden;border: 1px solid #f9f3f3;" class="text-block-html mb-3 ticketcontent" :style="$vuetify.theme.dark ? 'color: #dacdcd' : ''"></iframe>
                  </template>
                  <template v-else>
                    <div :class="$vuetify.theme.dark ? 'dark_theme_editor' : ''">
                      <ckeditor :editor="editor" v-model="updateMailInfo.body" :config="editorConfig" ref="editor"></ckeditor>
                    </div>
                  </template>
                <div v-if="item.attachments && item.attachments.length > 0">
                  <v-row>
                    <v-layout wrap>
                      <template v-for="(attachments, index) in item.imageAttachments">
                        <v-hover v-slot="{ hover }" :key="index">
                          <v-img :lazy-src="`${attachmentsURL}${attachments.filepath}`" :src="`${attachmentsURL}${attachments.filepath}`"
                            contain width="100" height="100" max-width="100" max-height="100" class="ma-1 elevation-1">
                            <v-expand-transition>
                              <div v-if="hover" class="custom_icon_style_container d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                              <v-icon class="custom_image_action_icon" @click="downloadFile(attachments.id)" dark>mdi-download</v-icon>
                              <v-icon class="custom_image_action_icon" v-if="attachments.sharepointurl" @click="openAttachment(attachments.sharepointurl)" dark>mdi-eye</v-icon>
                              <v-icon class="custom_image_action_icon" v-else @click="syncAttachment(attachments.id)" dark>
                              {{ !attachmentLoader ? 'mdi-cloud-sync' : 'mdi-loading mdi-spin' }}
                              </v-icon>
                            </div>
                            </v-expand-transition>
                          </v-img>
                        </v-hover>
                      </template>
                      <v-col lg="3" md="3" v-for="(other, oIindex) in item.otherAttachments" :key="`other_${oIindex}`" class="pa-1">
                        <template>
                        <v-card outlined height="50">
                          <div class="attchment custom_py-2">
                            <v-row class="ma-0">
                              <v-col lg="1" class="pa-1">
                                <v-icon :color="other.color ? other.color : ''">{{ other.icon }}</v-icon>
                              </v-col>
                              <v-col lg="8" class="text-truncate pa-1 pl-3">
                                <span class="caption">{{ other.originalfilename }}</span>
                              </v-col>
                              <v-col lg="1" class="pa-1 pl-0">
                                  <v-icon @click="downloadFile(other.id)">mdi-download</v-icon>
                              </v-col>
                              <v-col lg="1" class="pa-1 pl-2">
                                <v-icon v-if="other.sharepointurl" @click="openAttachment(other.sharepointurl)">mdi-eye</v-icon>
                                <v-icon v-else @click="syncAttachment(other.id)">
                                  {{ !attachmentLoader ? 'mdi-cloud-sync' : 'mdi-loading mdi-spin' }}
                                </v-icon>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card>
                        </template>
                      </v-col>
                    </v-layout>
                  </v-row>
                 </div>
              </v-sheet>
              <v-card outlined class="mt-2 pa-2" v-if="item.isShowMailForm">
                <v-form :ref="`mailForm_${index}`">
                  <v-row v-if="!modelObj.is_task">
                    <v-col lg="9" md="9" sm="8">
                      <div class="combo">
                        <v-combobox v-model="item.mailTo"  hide-selected  :rules="$_multiSelectValidation" :label="$t('message.tickets.to')" multiple persistent-hint small-chips outlined dense hide-details class="mb-1"></v-combobox>
                      </div>
                       <div class="combo">
                        <v-combobox v-model="item.mailCc" hide-selected  :label="$t('message.tickets.cc')" multiple persistent-hint small-chips  outlined dense v-if="item.showMailCc" hide-details class="mb-1"></v-combobox>
                      </div>
                      <div class="combo">
                        <v-combobox v-model="item.mailBcc" hide-selected  :label="$t('message.tickets.bcc')" multiple persistent-hint small-chips outlined dense v-if="item.showMailBcc" hide-details class="mb-1"></v-combobox>
                      </div>
                      <v-text-field label="Attachments"  prepend-icon='mdi-paperclip' dense outlined hide-details @click='pickFile(index)'></v-text-field>
                      <input type="file" style="display: none" id="attachments" :ref="`attachments_${index}`"  multiple @change="onFilePicked($event, index)">
                    </v-col>
                    <v-col lg="3" md="3" sm="4" class="text-center">
                      <v-btn color="primary" fab x-small dark class="mx-2" @click="showHideInput(item, index, 'cc')">
                        {{$t('message.tickets.cc')}}
                      </v-btn>
                      <v-btn color="info" fab x-small dark class="mx-2" @click="showHideInput(item, index, 'bcc')">
                        {{$t('message.tickets.bcc')}}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-layout wrap>
                      <template v-for="(image, imageIndex) in item.listOfFiles">
                        <v-hover v-slot="{ hover }" :key="`image_${imageIndex}`">
                          <v-img :src="image" contain height="100" width="100" max-height="100" max-width="100" class="ma-1 elevation-1">
                            <v-expand-transition>
                              <div v-if="hover"  class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                                <v-icon class="px-9" @click="removeAttachment(imageIndex, 'listOfFiles', index)" dark>mdi-close-circle-outline</v-icon>
                              </div>
                            </v-expand-transition>
                          </v-img>
                        </v-hover>
                      </template>
                      <v-col class="pa-1" lg="2" v-for="(files, fileIndex) in item.listOfOtherFiles" :key="`file_${fileIndex}`">
                        <v-card outlined height="50">
                          <div class="attchment custom_py-2">
                            <v-row class="ma-0">
                              <v-col lg="1" class="pa-1">
                                <v-icon :color="files.color">{{ files.icon }}</v-icon>
                              </v-col>
                              <v-col lg="8" class="text-truncate pa-1 pl-4">
                                <span class="caption">{{ files.name }}</span>
                              </v-col>
                              <v-col lg="2" class="pa-1">
                                <v-icon color="error" @click="removeAttachment(fileIndex, 'listOfOtherFiles', index)">mdi-close-circle-outline</v-icon>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card>
                      </v-col>
                    </v-layout>
                  </v-row>
                  <v-row>
                    <v-col>
                      <span v-if="modelObj.is_task">{{$t('message.tickets.description')}}</span>
                      <span v-else>{{$t('message.tickets.body')}}</span>
                        <ckeditor :editor="editor" v-model="item.mailBody" :config="editorConfig" ref="editor"></ckeditor>
                      <v-layout class="mt-2">
                        <v-btn color="info" @click="sendMailOrAttachment(item, index)" :loading="sendMailLoading" class="mx-2">{{$t('message.common.send')}}</v-btn>
                        <v-btn color="error" @click="cancelMail(item, index)" class="mx-2">{{$t('message.common.cancel')}}</v-btn>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-card>
        </v-card>
      </v-flex>
    </v-row>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDeleteDialog" persistent max-width="400px" class="mt-0">
       <v-card>
        <v-card-title>
          {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.tickets.deleteConfirm') }}
          <v-checkbox v-model="isDeleteMails" :label="$t('message.tickets.deleteMailsTo')" v-if="userDetails.role === 1"></v-checkbox>
          <span v-if="isDeleteMails" color="error">
           {{$t('message.tickets.note')}} : <code>{{$t('message.tickets.deleteNote')}}</code>
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="priority" :loading="deleteLoading" @click="deleteConfirmed">{{ $t('message.common.delete') }}</v-btn>
          <v-btn color="info" id="priorityclose" @click="showDeleteDialog=false,isDeleteMails=false">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Status close confirm -->
    <v-dialog v-model="cancloseDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
         {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <h4> {{ $t('message.tickets.noUserAssigned') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="setAssingedTo()" :loading="cancloseLoading">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="error" @click="closeConfirmDialog">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      modelObj: {
        id: +this.$route.params.ticket_id
      },
      ticketTerm: null,
      bodySignature: null,
      enableEditMode: false,
      mailsMerged: 0,
      MODULE_URL: 'tickets',
      ticketMails: [],
      editor: Editor,
      editorConfig: {
        height: '250px'
      },
      noteConfig: {
        height: '250px',
        sharedSpaces: {
          top: 'toolbarLocation'
        },
        toolbar: {
          items: [ 'bold', 'italic', 'outdent', 'indent', '|', 'bulletedList', 'numberedList', '|', 'insertTable', 'blockQuote', 'undo', 'redo']
        }
      },
      notesObj: {
        id: '',
        notes: ''
      },
      panel: [0],
      tab: null,
      sendMailLoading: false,
      isDeleteMails: false,
      showDeleteDialog: false,
      toggle_exclusive: 2,
      emailRegex: /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/,
      listOfNotes: [],
      fav: true,
      menu: false,
      message: false,
      hints: true,
      showNoteBox: false,
      selected: [],
      NOTES_MODULE: 'ticketnotes',
      backupTicket: {},
      listOFAirwayBills: [],
      listOfComments: [],
      showFieldsForTask: false,
      updateMailInfo: {},
      isForwardMail: false,
      cancloseDialog: false,
      cancloseLoading: false,
      userSignature: '',
      fieldsLoading: false,
      previewLoading: false,
      listOfCustomers: [],
      customerLoading: false,
      enableSearch: true,
      attachmentsURL: process.env.VUE_APP_ATTACHMENTS,
      attachmentLoader: false,
      deleteLoading: false,
      updateLoading: false,
      relatedOrders: [],
      settingsObj: {}
    }
  },
  components: {
    'form-data': FormTemplate,
    'comments-section': () => import('./Comments.vue')
  },
  filters: {
    singularPluralData: function (value) {
      let msg = `Merged ${value} mail${value > 1 ? 's' : ''}`
      return msg
    }
  },
  computed: {
    ...mapState(['FORM_TYPE', 'userDetails', 'listOfUsers', 'listOfTicketPriorities', 'listOfTicketStatus', 'listOfGroups', 'listOfTicketCategories']), // , 'listOfCustomers'
    formReferences () {
      let item = {
        title: ``,
        properties: [{
          model: 'customerid',
          live_search_model: 'customerSearch',
          type: this.FORM_TYPE.AUTO_COMPLETE_LIVE,
          items: this.listOfCustomers,
          select_text: 'name',
          select_value: 'id',
          rules: [],
          class: 'sm12',
          label: this.$t('message.order.customer'),
          loading: this.customerLoading
        }, {
          model: 'assignedto',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.getUsersAndGroups,
          select_text: 'fullname',
          select_value: 'alternateid',
          change: this.changeStatus,
          label: this.$t('message.tickets.assignedTo'),
          class: 'sm12'
        }, {
          model: 'priority',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.listOfTicketPriorities,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.tickets.changePriority'),
          class: 'sm12'
        }, {
          model: 'status',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.listOfTicketStatus,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.tickets.status'),
          class: 'sm12'
        }, {
          model: 'category_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfTicketCategories,
          select_text: 'name',
          select_value: 'id',
          class: 'sm12',
          label: this.$t('message.settings.category')
        } /* , {
          model: 'tags',
          type: this.FORM_TYPE.COMBOBOX,
          rules: [],
          multiple: true,
          items: [],
          label: this.$t('message.tickets.tags'),
          class: 'sm12'
        } */],
        buttons: [{
          name: 'update_ticket',
          color: 'success',
          class: 'mb-1',
          label: this.$t('message.common.update'),
          click: () => this.checkStatusClosed('SAVE'),
          // eslint-disable-next-line
          loading: this.updateLoading,
          is_show: true
        }, {
          name: 'delete_ticket',
          color: 'error',
          label: this.$t('message.common.delete'),
          class: 'mb-1',
          click: () => this.deleteHandler(),
          loading: this.deleteLoading,
          is_show: true
        }, {
          name: 'convert_ticket',
          color: 'info',
          class: 'mb-1',
          label: this.modelObj.is_task ? this.$t('message.tickets.convertToTicket') : this.$t('message.tickets.convertToTask'),
          click: () => this.convertTypeHandler(),
          is_show: true,
          loading: false
        }, {
          name: 'convert_to_offer',
          color: 'info',
          class: 'mb-1',
          label: this.$t('message.tickets.createOffer'),
          click: () => this.createOfferOrSales('offer'),
          is_show:  true, // no condition for now
          loading: false
        }, {
          name: 'convert_to_sales',
          color: 'info',
          class: 'mb-1',
          label: this.$t('message.orders.createSales'),
          click: () => this.createOfferOrSales('sales'),
          is_show:  true, // no condition for now
          loading: false
        }]
      }
      return item
    },
    getUsersAndGroups () {
      let userList = this.$formatter.cloneVariable(this.listOfUsers)
      let list = [ ...userList ]
      return list
    },
    tabs () {
      return [{
        id: 0,
        name: this.$t('message.order.details')
      }, {
        id: 1,
        name: this.$t('message.common.comments')
      }]
    }
  },
  mounted () {
    this.getTicketTerm()
    this.getInvoiceSettings()
    if (this.modelObj.id) {
      this.getSingleRecordHandler()
      this.enableEditMode = true
      this.getRelatedOrders()
    }
    this.getListOfNotes()
    // this.$store.dispatch('getCustomersList')
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getPriority')
    this.$store.dispatch('getStatus')
    this.$store.dispatch('getTicketCategory')
    const text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.NOTES_MODULE) {
        const payload = { ids: data.ids, url: `${this.NOTES_MODULE}/delete_multiple`, module: this.NOTES_MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$root.$on('loadComments', (data) => {
      this.getAllComments(data)
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.NOTES_MODULE) {
        this.selected = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListOfNotes()
      }
    })
  },
  methods: {
    changeStatus () {
      if (this.modelObj.status === parseInt(process.env.VUE_APP_TICKET_STAUS_NEW)) this.modelObj.status = parseInt(process.env.VUE_APP_TICKET_STAUS_INPROGRESS)
    },
    addToSelected (event, item) {
      if (event) {
        this.selected.push(item)
      } else {
        const result = this.selected.filter(x => x.id !== item.id)
        if (result) {
          this.selected = result
        }
      }
    },
    pickFile (index) {
      const name = `attachments_${index}`
      this.$refs[name][0].click()
    },
    async onFilePicked (e, index) {
      let item = this.$formatter.cloneVariable(this.ticketMails[index])
      const files = e.target.files
      for (let file of files) {
        if (file) {
          if (!item.attachmentsList) item.attachmentsList = []
          item.attachmentsList.push(file.name)
          if (!item.attachmentsFiles) item.attachmentsFiles = []
          item.attachmentsFiles.push(file)
          if (this.imagesTypes.includes(file.type)) {
            let base64 = await this.toBase64(file)
            if (!item.listOfFiles) item.listOfFiles = []
            item.listOfFiles.push(base64)
            this.$set(this.ticketMails, index, item)
          } else {
            if (!item.listOfOtherFiles) item.listOfOtherFiles = []
            let iconObj = this.getMimeTypeIcons(file.type)
            item.listOfOtherFiles.push({ name: file.name, type: file.type, ...iconObj })
            this.$set(this.ticketMails, index, item)
          }
        }
      }
    },
    deleteNotes () {
      const ids = this.selected.map(x => x.id)
      const data = { module: this.NOTES_MODULE, ids }
      this.$eventBus.$emit('deleteItems', data)
    },
    backToList () {
      this.$router.push(`/${this.MODULE_URL}`)
    },
    toggleEditMode () {
      this.enableEditMode = !this.enableEditMode
    },
    supportingList (type, text) {
      text = this.$refs.ticketViewEditReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text }
      this.$store.commit('supportingList', model)
    },
    getListOfNotes () {
       let query = {
        filter: `ticket_id eq ${this.modelObj.id}`,
        expand: [{
          select: ['firstname', 'lastname'],
          model: 'User',
          on_field: 'id',
          on_parent_field: 'user_id',
        }]
      }
      this.$_executeApi('post', `/ticketnotes/query`, query).then(response => {
        this.listOfNotes = response.data
        this.listOfNotes.forEach(element => {
          element.showEdit = false
        })
      })
    },
    saveNotes () {
      let model = {
        id: this.$formatter.cloneVariable(this.notesObj.id) ? this.$formatter.cloneVariable(this.notesObj.id) : undefined,
        ticket_id: this.modelObj.id,
        user_id: this.$store.state.userDetails.id,
        note: this.$formatter.cloneVariable(this.notesObj.notes)
      }
      this.$_executeApi(model.id ? 'put' : 'post', model.id ? `/ticketnotes/${model.id}` : `/ticketnotes`, model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        this.showNoteBox = false
        this.notesObj = {}
        this.getListOfNotes()
      })
    },
    editNotes (index) {
      let note = this.$formatter.cloneVariable(this.listOfNotes[index])
      this.notesObj.id = note.id
      this.notesObj.notes = note.note
      this.showNoteBox = true
    },
    getSingleRecordHandler () {
      let query = {
        filter: `id eq ${this.modelObj.id}`,
        expand: [{
          select: ['name', 'username'],
          model: 'MailConfiguration',
          on_field: 'id',
          on_parent_field: 'mailboxid',
        }, {
          'select': ['name'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'customerid'
        }]
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((response) => {
          let result = response && response.data ? response.data[0] : {}
          if (result && result.tags) {
            result.tags = JSON.parse(result.tags)
          }
          if (result.assignedto) {
            result.assignedto = `user_${result.assignedto}`
          } else if (result.assignedto_group) {
            result.assignedto = `group_${result.assignedto_group}`
          }
          this.backupTicket = this.$formatter.cloneVariable(result)
          /*  */
          if (result.customerid) {
            this.enableSearch = false
            const customerObj = { id: result.customerid, name: result.customer_name }
            this.listOfCustomers.push(customerObj)
          }
          /*  */
          this.modelObj = result
          this.getTicketMails()
          this.getAllComments(this.modelObj.id)
          const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
          this.bodySignature = `<br /><br />${mail_signature} <p></p><p><strong>[${this.ticketTerm  ? this.ticketTerm : ''}#${this.modelObj.number}]</strong><iframe id="userSignFooter" frameborder="0" width="100%"></iframe></p>`
          // let signature = this.$store.state.userDetails.signature ? `${this.$store.state.userDetails.signature.replace('\n', '<br>')}` : ''
          // this.bodySignature = `<p></p><p style="margin-bottom:0px">${signature}</p><strong>[${this.ticketTerm  ? `${this.ticketTerm} ` : ''}#${this.modelObj.number}]</strong>`
        })
        .finally(() => {
          this.fieldsLoading = false
          setTimeout(() => {
            this.enableSearch = true
          }, 50)
        })
    },
    getRelatedOrders () {
       this.$_executeApi('get', `/orders/get_related_tickets/${this.modelObj.id}`)
        .then(response => {
          this.relatedOrders = response.data
        })
    },
    getAllComments (id) {
      let query = {
        filter: `ticket_id eq ${id}`,
        expand: [{
          select: ['firstname', 'lastname'],
          model: 'User',
          on_field: 'id',
          on_parent_field: 'updated_by',
        }]
      }
      this.$_executeApi('post', `/ticketcomments/query`, query).then(response => {
        this.listOfComments = response.data
        this.listOfComments.forEach(element => {
          if (element.updated_by === -100) {
            element.user_firstname = "Super"
            element.user_lastname = "Admin"
          }
          if (!element.user_firstname) element.user_firstname = 'Unknown'
          element.showEdit = false
        })
      })
    },
    openAttachment (url) {
      window.open(url, '_blank')
    },
    syncAttachment (id) {
      this.attachmentLoader = true
      this.$_executeApi('post', `sharepoint/upload_from_ticket/${this.modelObj.id}/${id}`).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'syncSuccessful' })
        this.attachmentLoader = false
        this.getTicketMails()
      })
    },
    getTicketTerm () {
      this.$_executeApi('get', 'systemconfigurations').then(response => {
        if (response) {
          this.ticketTerm = response.data.ticketterm
        }
      })
    },
    getTicketMails () {
      let obj = { id: this.modelObj.mailid }
      this.previewLoading = true
      this.$_executeApi('post', 'mails/get_all', obj).then(response => {
        if (response) {
          let mergedMailsCount = 0
          let mails = this.$formatter.cloneVariable(response.data)
          let tempAllMails = []
          mails.forEach(mail => {
            if (mail.mergedmails && mail.mergedmails.length) {
              mergedMailsCount += mail.mergedmails.length
              tempAllMails.push(...mail.mergedmails)
              mail.mergedmails = null
            }
            tempAllMails.push(mail)
          })
          let uniqueItemFound = []
          tempAllMails.sort((a, b) => {
            if (a.mailid === b.mailid) uniqueItemFound.push(tempAllMails.indexOf(a))
          })
          /* Remove duplicate objects from array previous push is having only 1 index value remove, this is code is updated with multiple */
          uniqueItemFound.forEach(index => {
            tempAllMails.splice(index, 1)
          })
          var clonedArray = tempAllMails.map(function (mail) {
            mail.mailfrom = mail.mailfrom ? JSON.parse(mail.mailfrom) : ''
            mail.mailto = mail.mailto ? JSON.parse(mail.mailto) : ''
            mail.showMailCc = false
            mail.showMailBcc = false
            mail.mailcc = mail.mailcc ? JSON.parse(mail.mailcc) : ''
            mail.mailbcc = mail.mailbcc ? JSON.parse(mail.mailbcc) : ''
            mail.isShowMailForm = false
            return mail
          })
          clonedArray.sort((a, b) => {
            let date1 = a.datetime
            let date2 = b.datetime
            return this.$_sortWithDates(date2, date1, 'DD.MM.YYYYTHH:mm:ss')
          })
          clonedArray.forEach(element => {
            element.imageAttachments = []
            element.otherAttachments = []
            if (element.attachments && element.attachments.length > 0) {
              element.attachments.forEach(attachment => {
                let getExtensionType = this.mimeTypeOfDocument(attachment.extension)
                if (getExtensionType === 'mdi-file-image') {
                  element.imageAttachments.push({ ...attachment, icon: getExtensionType, color: '' })
                } else element.otherAttachments.push({ ...attachment, icon: getExtensionType.icon, color: getExtensionType.color })
              })
            }
          })
          this.mailsMerged = mergedMailsCount
          this.ticketMails = this.$formatter.cloneVariable(clonedArray)
          this.previewLoading = false
        }
      })
      .catch(() => {
        this.previewLoading = false
      }).finally(() => {
        var imgs = document.getElementsByTagName("img");
        for (let img  of imgs) {
           img.style.removeProperty('zoom')
        }
        this.fieldsLoading = false
      })
    },
    convertTypeHandler () {
      let queryname = ''
      let taskOrTicketInfo = this.$formatter.cloneVariable(this.modelObj)
      if (taskOrTicketInfo) {
        let filteredMail = this.$formatter.cloneVariable(this.ticketMails.find(x => x.mailid === taskOrTicketInfo.mailid))
        taskOrTicketInfo.body = filteredMail ? filteredMail.body : ''
        taskOrTicketInfo.subject = filteredMail ? filteredMail.subject : ''
      }
      /* if customer selected then set the customer */
      if (taskOrTicketInfo.customerid && this.listOfCustomers && this.listOfCustomers.length) {
        let selectedCustomer = this.listOfCustomers.find(x => x.id === taskOrTicketInfo.customerid)
        if (selectedCustomer) taskOrTicketInfo.customers = [selectedCustomer]
      }
      /* --- */
      if (taskOrTicketInfo.is_task) queryname = 'ticket'
      else queryname = 'task'
      window.localStorage.setItem('taskOrTicketInfo', JSON.stringify(taskOrTicketInfo))
      this.$router.push(`/tickets/create?type=${queryname}`)
    },
    createOfferOrSales (type) {
      let obj = this.$formatter.cloneVariable(this.modelObj)
      let customerArray = []
      /* if customer selected then set the customer */
      if (obj.customerid && this.listOfCustomers && this.listOfCustomers.length) {
        let selectedCustomer = this.listOfCustomers.find(x => x.id === obj.customerid)
        if (selectedCustomer) customerArray.push(selectedCustomer)
      }
      let assignedTo = this.$store.state.userDetails.id
      if (obj.assignedto) {
        let splitValue = obj.assignedto.split('_')
        if (splitValue[0] !== 'group') assignedTo = splitValue[1]
      }
      /* --- */
      const model = {
        resposible: +assignedTo,
        customer: obj.customerid,
        ticketid: obj.id
      }
      this.$router.push(`/orders/actions?type=${type}&fromticket=${encodeURIComponent(JSON.stringify(model))}`)
    },
    checkStatusClosed () {
      let model = this.$formatter.cloneVariable(this.modelObj)
      if (!model.assignedto && !model.assignedto_group) {
        let statusItem = this.listOfTicketStatus.find(x => x.id === model.status)
        if (statusItem && statusItem.canclose) {
          this.cancloseDialog = true
          // this.statusItem = item
        } else this.saveUpdateHandler()
      } else {
        this.saveUpdateHandler()
      }
    },
    setAssingedTo () {
      this.cancloseLoading = true
      this.modelObj.assignedto = `user_${this.userDetails.id}`
      this.cancloseDialog = false
      this.cancloseLoading = false
      this.saveUpdateHandler()
    },
    closeConfirmDialog () {
      this.cancloseDialog = false
      this.cancloseLoading = false
    },
    saveUpdateHandler (type) {
      if (this.$refs.ticketViewEditReference[0].$refs.validateForm.validate()) {
        this.updateLoading = true
        let model = this.$formatter.cloneVariable(this.modelObj)
        model.tags = model.tags ? JSON.stringify(model.tags) : ''
        let assignedTo = []
        let assignedToBackup = model.assignedto
        if (model.assignedto) {
          assignedTo = model.assignedto.split('_')
          if (assignedTo[0] === 'user') {
            model.assignedto = assignedTo[1]
            model.assignedto_group =  0
          } else {
            model.assignedto = 0
            model.assignedto_group =  assignedTo[1]
          }
        }
        let url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model).then((response) => {
          if (response.snackbar && response.snackbar.text) this.$root.$emit('snackbar', { ...response.snackbar, text: this.$t(response.snackbar.text)})
          let msg = ''
          if (assignedTo.length > 0) {
            if (model.status !== this.backupTicket.status) {
            let oldStatus = this.listOfTicketStatus.find(x => x.id === this.backupTicket.status)
            let newStatus = this.listOfTicketStatus.find(x => x.id === model.status)
            if (!oldStatus) msg = `${this.$t('message.tickets.statusSet')} ${newStatus.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            else  msg = `${this.$t('message.tickets.statusChanged')} ${oldStatus.name} ${this.$t('message.tickets.to')} ${newStatus.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
          } else if (assignedToBackup !==  this.backupTicket.assignedto) {
            if (assignedTo[0] === 'user') msg = `${this.$t('message.tickets.assignedtoMessage')} ${this.backupTicket.number}  ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            else msg = this.sendAssignedNotification(this.backupTicket.number, assignedTo[1])
          } else if (model.priority !==  this.backupTicket.priority) {
            let oldPriority = this.listOfTicketPriorities.find(x => x.id === this.backupTicket.priority)
            let newPriority = this.listOfTicketPriorities.find(x => x.id === model.priority)
            if (!oldPriority) msg =`${this.$t('message.tickets.prioritySet')} ${newPriority.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number}  ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            else msg = `${this.$t('message.tickets.priorityChanged')} ${oldPriority.name} ${this.$t('message.tickets.to')} ${newPriority.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number}  ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
          } else if (model.category_id !==  this.backupTicket.category_id) {
            let oldCategory = this.listOfTicketCategories.find(x => x.id === this.backupTicket.category_id)
            let newCategory = this.listOfTicketCategories.find(x => x.id === model.category_id)
            if (!oldCategory) msg = `${this.$t('message.tickets.categorySet')} ${newCategory.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number}  ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            else msg = `${this.$t('message.tickets.categoryChanged')} ${oldCategory.name} ${this.$t('message.tickets.to')} ${newCategory.name} ${this.$t('message.tickets.for')} ${this.backupTicket.number}  ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            } else {
              msg = `Airway bill updated for ${this.backupTicket.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            }
            if (assignedTo[0] === 'group') {
              // let usersarray = []
              // let query = { filter: `groupid eq ${assignedTo[1]} and isactive eq 1` }
              // this.$_executeApi('get', `usergroups/get_by_group/${assignedTo[1]}`).then(result => {
              //   usersarray = result.data.map(x => x.user_id)
              // }).finally(() => {
              //   this.getsignalRConnection.invoke('SendNotification', usersarray, msg, response.id)
              // })
            } else {
              if (assignedTo[1] != this.$store.state.userDetails.id) {
                this.$eventBus.$emit('SendNotification', [assignedTo[1]], msg, response.id)
              }
            }
          }
        }).finally(() => {
          this.updateLoading = false
          this.getSingleRecordHandler()
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    sendAssignedNotification (number, groupID, ticketid) {
      let group =  this.listOfGroups.find(x => x.id == groupID)
      let msg = `${group.name} is assigned for ${number} by ${this.$store.state.userDetails.name}`
      return msg
    },
    deleteConfirmed () {
      this.deleteLoading = true
      let modelObj = { data: { ids: [this.modelObj.id], delete_mails: this.isDeleteMails } }
      this.$_executeApi('delete', `${this.MODULE_URL}/delete_multiple`, modelObj)
        .then(response => {
          if (response && response.data) {
            let text = this.$t('message.common.deleteSuccess')
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
            this.$router.push(`/${this.MODULE_URL}`)
          }
        })
        .finally(() => {
          this.showDeleteDialog = false
          this.deleteLoading = false
        })
    },
    deleteHandler () {
      this.showDeleteDialog = true
    },
    convertHtml ({ body } = {}) {
      // const regex = /[a-zA-Z]{6,9}, [a-zA-Z]{3,9} \d{1,2}, \d{4} \d{1,2}:\d{2} [a-zA-Z]{2}/
      // const result = body.match(regex) || []
      // if (result && result[0]) return body.replace(result[0], this.$formatter.UtcToLocal(result[0], 'dddd, MMMM DD, YYYY HH:mm A'))
      return body
    },
    replyMail (item, index) {
      let mailAddress = this.ticketMails[index].mailfrom && this.ticketMails[index].mailfrom.length > 0 ? item.mailfrom.map(function(elem){return elem.Address}) : []
      let itemObj = Object.assign({ ...item }, { isShowMailForm: true, mailTo: mailAddress, mailBody: !this.modelObj.is_task ? this.bodySignature : '',
        showMailCc: false, showMailBcc: false, mailCc: [], mailBcc: [] })
      this.isForwardMail = false
      this.$set(this.ticketMails, index, itemObj)
      setTimeout(() => {
        this.focusMessageArea(index)
      })
    },
    replyAllMail (item, index) {
      let mailAddress = this.ticketMails[index].mailto && this.ticketMails[index].mailto.length > 0 ? item.mailto.map(function(elem){return elem.Address}) : []
      let from = this.ticketMails[index].mailfrom && this.ticketMails[index].mailfrom.length > 0 ? item.mailfrom.map(function(elem){return elem.Address}) : []
      if (from) {
        mailAddress = [...mailAddress, ...from]
      }
      let mailCc = item.mailcc.length > 0 ? item.mailcc.map(function(elem){return elem.Address}) : []
      let mailBcc = item.mailbcc.length > 0 ?  item.mailbcc.map(function(elem){return elem.Address}) : []
      if (this.modelObj.mailconfiguration_username) mailAddress = mailAddress.filter(x => x !== this.modelObj.mailconfiguration_username)
      let itemObj = Object.assign({ ...item }, { isShowMailForm: true, mailTo: mailAddress, mailCc, mailBcc, mailBody: !this.modelObj.is_task ? this.bodySignature : '',
        showMailCc: mailCc.length > 0 ? true : false, showMailBcc: mailBcc.length > 0 ? true : false })
      this.isForwardMail = false
      this.$set(this.ticketMails, index, itemObj)
      setTimeout(() => {
        this.focusMessageArea(index)
      })
    },
    forwardMail (item, index) {
      let itemObj = Object.assign({ ...item }, { isShowMailForm: true, mailTo: [], mailBody: !this.modelObj.is_task ? this.bodySignature : '' })
      this.$set(this.ticketMails, index, itemObj)
      this.isForwardMail = true
      setTimeout(() => {
        this.focusMessageArea(index)
      })
    },
    focusMessageArea (index) {
      setTimeout(() => {
        var div = document.getElementsByClassName('ck-editor__editable_inline')
        if (div && div.length === 1) index = 0
        setTimeout(function() {
          if (div[index]) div[index].focus()
        }, 50)
      }, 100)
      let item = ''
      let currentUser = this.listOfUsers.find(x => x.id === this.userDetails.id)
      if (currentUser && currentUser.signature) {
        item = `${currentUser.signature}`
        document.getElementById('userSignFooter').srcdoc = item
        setTimeout(() => {
          let element = document.getElementById('userSignFooter')
          element.style.height = (element.contentWindow.document.all[2].offsetHeight + 30) + 'px'
          element.style.pointerEvents = 'none'
        }, 300)
      }
    },
    showHideInput (item, index, field) {
      if (field === 'cc') {
        item.showMailCc = !item.showMailCc
      } else item.showMailBcc = !item.showMailBcc
      this.$set(this.ticketMails, index, item)
    },
    sendMailOrAttachment (item, index) {
      if (this.$refs[`mailForm_${index}`][0].validate()) {
        if ((item.listOfFiles && item.listOfFiles.length > 0) || (item.listOfOtherFiles && item.listOfOtherFiles.length > 0)) {
          var formData = new FormData()
          var filesList = item.attachmentsFiles
          if (filesList !== null && filesList.length > 0) {
            filesList.forEach(file => {
              formData.append(file.name, file)
            })
          }
          this.sendMailLoading = true
          this.$_executeApi('post', 'mailattachments/upload', formData).then(response => {
            if (response.data && response.data.length > 0) {
              let attachmentIds = response.data.map(x => x.id)
              item.attachments = attachmentIds
              this.$set(this.ticketMails, index, item)
              setTimeout(() => {
                this.sendMail(item, index, true)
              }, 100)
            }
          })
        } else this.sendMail(item, index)
      }
    },
    sendMail (item, index, addedAttachments) {
      let mailItem = this.$formatter.cloneVariable(item)
      if (this.$refs[`mailForm_${index}`][0].validate()) {
        let body = this.$formatter.isArrayHasData(mailItem.mailBody) ? mailItem.mailBody : ''
        let to = this.$formatter.isArrayHasData(mailItem.mailTo) ? mailItem.mailTo : []
        let cc = this.$formatter.isArrayHasData(mailItem.mailCc) ? mailItem.mailCc : []
        let bcc = this.$formatter.isArrayHasData(mailItem.mailBcc) ? mailItem.mailBcc : []
        let arrayOfEmails = [to, cc, bcc]
        if (arrayOfEmails.length > 0) {
          for (let i = 0; i < arrayOfEmails.length; i++) {
            for (let j = 0; j < arrayOfEmails[i].length; j++) {
              if (!this.emailRegex.test(arrayOfEmails[i][j])) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'Invalid Email' })
                return false
              }
            }
          }
        }
        this.sendMailLoading = true
        if (body) {
          body = body.replace('<iframe width="100%" frameborder="0" id="userSignFooter">�</iframe>', '')
          body = body.replace('<iframe id="userSignFooter" frameborder="0" width="100%"></iframe>', '')
          body = body.replace('<iframe width="100%" frameborder="0" id="userSignFooter"> </iframe>', '')
        } else body = ''
        let sendObj = {
          mailid: mailItem.mailid,
          from: this.ticketMails[index].from,
          body: body,
          to: to,
          cc: cc,
          bcc: bcc,
          attachments: addedAttachments && item.attachments && item.attachments.length > 0 ? item.attachments : [],
          ticket_id: [this.modelObj.id]
        }
        let url = '/mails/reply'
        if (this.isForwardMail) url = '/mails/forward'
        this.$_executeApi('post', url, sendObj)
          .then((response) => {
            item.listOfOtherFiles = []
            item.listOfFiles = []
            item.attachmentsFiles = []
            if (response.status === 200) {
              if (response.data) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                item.isShowMailForm = false
                this.$set(this.ticketMails, index, item)
                this.getSingleRecordHandler()
              }
            }
          })
          .finally(() => {
            this.sendMailLoading = false
          })
      }
    },
    cancelMail (item, index) {
      item.isShowMailForm = false
      this.$set(this.ticketMails, index, item)
    },
    autoFocusOnField () {
      setTimeout(() => {
        var div = document.getElementsByClassName('ck-editor__editable_inline')
        if (div && div[div.length - 1]) div[div.length - 1].focus()
      }, 100)
    },
    addNotesHandler () {
      this.showNoteBox = true
      this.autoFocusOnField()
    },
    mimeTypeOfDocument (type) {
      let icon = ''
      switch (type) {
        case '.png':
        case '.jpeg':
        case '.jpg':
        case '.gif':
        case '.jfif':
          icon = 'mdi-file-image'
          break
        case '.pdf':
          icon = { icon:  'mdi-file-pdf-box' , color: 'red' }
          break
        case '.xlsx':
          icon = { icon:  'mdi-file-excel' , color: 'green' }
          break
        case '.html':
          icon = { icon:  'mdi-language-html5' , color: '' }
          break
        case '.mp4':
          icon = { icon:  'mdi-file-video' , color: '' }
          break
        case '.mpeg':
          icon = 'mdi-audiobook'
          break
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
          icon = { icon: 'mdi-file-word', color: 'info' }
          break
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
          icon = { icon: 'mdi-file-excel', color: 'green' }
          break
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.openxmlformats-officedocument.presentationml.template':
        case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
          icon = { icon: 'mdi-file-powerpoint', color: 'error' }
          break
        case 'application/x-rar-compressed':
        case 'application/octet-stream':
        case 'application/zip':
        case 'application/x-zip-compressed':
        case 'multipart/x-zip':
          icon = { icon: 'mdi-zip-box', color: null }
          break
        default:
          icon = { icon: 'mdi-file-cloud', color: null }
          break
      }
      return icon
    },
    downloadFile (id) {
      window.open(process.env.VUE_APP_URL + 'mailattachments/download/' + id, '_blank')
    },
    showMailInfoEdit (item, index) {
      this.updateMailInfo = this.$formatter.cloneVariable(item)
      this.showFieldsForTask = true
    },
    updateMailValues () {
      let model = this.$formatter.cloneVariable(this.updateMailInfo)
      model.attachments = []
      this.$_executeApi('post', `mails/update_task/${this.modelObj.id}`, model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
        this.showFieldsForTask = false
        this.getSingleRecordHandler()
      })
    },
    loadCustomerList (searchTerm) {
      this.customerLoading = true
      this.listOfCustomers = []
      this.$_executeApi('get', `customers/search?search_term=${searchTerm}`).then((response) => {
        this.listOfCustomers = response.data
      }).finally(() => {
        this.customerLoading = false
      })
    },
    getCreatedBy () {
      let name = ''
      if (this.modelObj && this.modelObj.createdby) {
        let user = this.listOfUsers.find(x => x.id === this.modelObj.createdby)
        if (user) name = user.fullname// `${user.firstname || ''} ${user.lastname || ''}`
      }
      return name
    },
    removeAttachment (fileIndex, listname, mainIndex) {
      let item =  this.$formatter.cloneVariable(this.ticketMails[mainIndex])
      item[listname].splice(fileIndex, 1)
      this.$set(this.ticketMails, mainIndex, item)
    },
    getInvoiceSettings () {
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    isHTML (str) {
      var doc = new DOMParser().parseFromString(str, 'text/html')
      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
    }
  },
  watch: {
    'modelObj.customerSearch' (val) {
      if (val === undefined) return
      if (val && !val.includes('-') && this.enableSearch) this.loadCustomerList(val)
    }
  },
  beforeDestroy () {
    this.$root.$off('loadComments')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style>
.custom-ckeditor-height .ck-content {
  min-height: 120px;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px !important;
}
.notes-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 160px;
  height: 1.2em;
  white-space: nowrap;
}
.notes-wrapper {
    min-width: 100px !important;
    background-color: rgba(0, 0, 0, 0.3) !important;
    border-color: rgba(0, 0, 0, 0.3) !important;
    position: fixed !important;
    top: 115px !important;
    right: -35px !important;
    border-radius: 8px !important;
}
.image img {
  height: 400px;
}
.custom_py-2 {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}
.custom_icon_style_container {
  align-items: center;
  justify-content: center;
}
.custom_image_action_icon {
  height: 24px;
  margin: 0 5%;
}
.text-block-html {
  white-space: pre;
}
</style>
